const images = {
    meet: require('../images/meet.png'),
    teams: require('../images/teams.png'),
    zoom: require('../images/zoom.png'),
    denwaMeet: require('../images/denwa-meeting.png')
};
export default images;